module.exports = __webpack_public_path__ + "static/media/OrderBanner.18da26ed.png";